<!--
    Clubs & Societies view for UofG Life.
    @author crm4f
-->

<template>
  <div id="contain" class="container">
    <Nav name="Clubs &amp; Societies" />

    <div class="tilesBlurb">
      <Announcement category="41" />
    </div>

    <div class="orgHeader">
      <h1>SRC</h1>
    </div>

    <div class="tileQuadrant">
      <div class="clubTileContainer" v-bind:key="index" v-for="tile, index in srcTiles">
          <div class="tile" @click="go(SRC_LINK_PREFIX + tile.path)">
            <div class="tileImgContainer">
              <img class="tileImg" :src="SRC_IMG_PREFIX + tile.path + '/' + tile.image">
            </div>
          </div>
          <span class="tileTitle">{{ tile.title }}</span>
      </div>
    </div>

    <div class="tilesFooter" style="background-color: #003865;">
      <div class="tilesFooterContent">
        <p>
          For the full list of all the clubs and societies, you can download the SRC app. Alternatively, visit
          <a style="color: #fff; text-decoration: none; border-bottom: 1px solid #fff;" href="https://www.glasgowunisrc.org/clubs-socs/find/" target="_new">
            the SRC website
            <font-awesome-icon style="font-size: 15px; color: #fff;" icon="external-link" size="lg"></font-awesome-icon>
          </a>
        </p>
      </div>
      <AppStoreLink iosLink="https://apps.apple.com/gb/app/glasgow-uni-src/id1641374855" androidLink="https://play.google.com/store/apps/details?id=com.ukmsl.studentlinkplus.gusrc&hl=en_GB&gl=US&pli=1" :displayOnlyWeb="1!==1" />
    </div>

    <div class="orgHeader" style="margin-top: 10px;">
      <h1>UofG Sport</h1>
    </div>

    <div class="tileQuadrant">
      <div class="clubTileContainer" v-bind:key="index" v-for="tile, index in gusaTiles">
          <div class="tile" @click="go(GUSA_LINK_PREFIX + tile.path)">
            <div class="tileImgContainer">
              <img class="tileImg" :src="tile.image == 'DEFAULT' ? require('@/assets/clubs/defaultsport.png') : GUSA_IMG_PREFIX + tile.image">
            </div>
          </div>
          <span class="tileTitle">{{ tile.title }}</span>
      </div>
    </div>

    <div class="tilesFooter" style="background-color: #FFDC36;">
      <div class="tilesFooterContent" style="color: #1D1D1D;">
        <p>
          For the full list of all the sports clubs, you can download the UofG Sport app. Alternatively, visit
          <a style="color: #1D1D1D; text-decoration: none; border-bottom: 1px solid #1D1D1D;" href="https://www.gla.ac.uk/myglasgow/sport/whatson/club/" target="_new">
            their website
            <font-awesome-icon style="font-size: 15px; color: #1D1D1D;" icon="external-link" size="lg"></font-awesome-icon>
          </a>
        </p>
      </div>
      <AppStoreLink iosLink="https://apps.apple.com/gb/app/uofg-sport/id1520622054" androidLink="https://play.google.com/store/apps/details?id=com.innovatise.uofgsport&hl=en_US" :displayOnlyWeb="1!==1" />
    </div>

    <div id="pusher"></div>
    <Footer active="clubs"/>
  </div>
</template>

<script setup>
import AppStoreLink from '@/components/AppStoreLink.vue'
import Announcement from '@/components/Announcement.vue'
import Footer from '@/components/FooterMenu.vue'
import Nav from '@/components/Navbar.vue'
import { onMounted, ref } from 'vue'
import axios from 'axios'

const srcTiles = ref([])
const gusaTiles = ref([])
const SRC_IMG_PREFIX = 'https://www.glasgowunisrc.org/asset/organisation/'
const SRC_LINK_PREFIX = 'https://www.glasgowunisrc.org/organisation/'
const GUSA_IMG_PREFIX = 'https://www.gla.ac.uk/media/'
const GUSA_LINK_PREFIX = 'https://www.gla.ac.uk/myglasgow/sport/whatson/club/'

onMounted(() => {
  getSrcTiles()
  getGusaTiles()
})

function getSrcTiles () {
  axios.get('/timetable/clubs/src')
  .then(response => {
    srcTiles.value = response.data
  }).catch((error) => {
    console.log(error)
  })
}

function getGusaTiles () {
  axios.get('/timetable/clubs/gusa')
  .then(response => {
    gusaTiles.value = response.data
  }).catch((error) => {
    console.log(error)
  })
}

function go (link) {
  window.location.href = link
}
</script>

<style lang="scss">

.orgHeader {
  color: #003865;
  margin: 0px 15px 0px 15px;
}

.orgHeader h1 {
  font-weight: bold;
}

.tileQuadrant {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  height: 100%;
  grid-column-gap: 20px;
  grid-row-gap: 15px;
  margin: 10px 15px 15px 15px;
  height: fit-content;
}

.clubTileContainer {
  display: flex;
  align-items: center;
  justify-content: start;
  min-width: 0;
  flex-direction: column;
  max-height: 100%;
  max-width: 100%;
  height: fit-content !important;
}

.tileImgContainer {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 0;
  max-height: 100%;
  height: 100%;
}

.tileImg {
  border-radius: 30px;
  border: 1px solid rgb(220, 220, 220);
  aspect-ratio: 1/1 !important;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: fit-content !important;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
}

.tile {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content !important;
  cursor: pointer;
}

.tileTitle {
  width: fit-content;
  color: #003865;
  text-align: center;
  margin: auto;
  font-weight: bold;
  word-break: break-word;
}

.tilesBlurb {
  font-weight: bold;
  color: #003865;
  margin: 15px 15px 10px 15px;
}

.tilesFooter {
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.tilesFooterContent {
  color: #fff;
  font-weight: bold;
}

.text-center img {
  margin: 5px !important;
}

@media screen and (min-width: 1000px) {
  .tile {
    width: 65% !important;
  }
  .tileQuadrant {
    grid-row-gap: 25px;
  }
}

@media screen and (min-height: 1000px) {
  .tilesFooter {
    height: 50vh;
  }
}
</style>
